import en from "@/messages/en-IN.json";
import hi from "@/messages/hi-IN.json";
import { createTranslator } from "use-intl/core";
import type { CounterLocale } from "@/lib/i18n/config";

/**
 * Both catalogs, bundled.
 *
 * The till is a client-rendered app whose language is decided after `/pos/context` answers, so the
 * catalogs travel with the bundle rather than being fetched per request. Together they are a few KB.
 * `en-IN` is the shape; `scripts/check-i18n.ts` fails the build when `hi-IN` drifts from it.
 */
export type CounterMessages = typeof en;

export const MESSAGES: Record<CounterLocale, CounterMessages> = {
  "en-IN": en,
  "hi-IN": hi as CounterMessages,
};

/**
 * A translator outside React — for pure helpers whose callers are both a screen (which passes its own
 * `useTranslations()` result) and a test or script (which gets English).
 */
export type Translate = ReturnType<typeof createTranslator<CounterMessages>>;

export function translatorFor(locale: CounterLocale): Translate {
  return createTranslator({ locale, messages: MESSAGES[locale] });
}
